"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2843],{

/***/ 94477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70917);






// const imageLoader = ({ src, width, quality }) => {
//     return `https://example.com${src}?w=${width}&q=${quality || 75}`
// }
function Image(_param) {
    var src = _param.src, alt = _param.alt, width = _param.width, height = _param.height, _layout = _param.layout, layout = _layout === void 0 ? "intrinsic" : _layout, _priority = _param.priority, priority = _priority === void 0 ? false : _priority, _objectFit = _param.objectFit, objectFit = _objectFit === void 0 ? "contain" : _objectFit, style = _param.style, _noStyle = _param.noStyle, noStyle = _noStyle === void 0 ? false : _noStyle, others = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "src",
        "alt",
        "width",
        "height",
        "layout",
        "priority",
        "objectFit",
        "style",
        "noStyle"
    ]);
    var r = /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        src: src,
        alt: alt,
        width: width,
        height: height,
        priority: priority,
        layout: layout,
        objectFit: objectFit,
        // loader={imageLoader}
        style: noStyle && typeof style !== "string" ? style : null
    }, others));
    return noStyle ? r : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("div", {
        className: "image",
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(style),
        children: r
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Image);


/***/ }),

/***/ 85887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20442);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82843);
/* harmony import */ var react_icons_io__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51649);





//TODO add a solid state and color
function Tag(param) {
    var children = param.children, _href = param.href, href = _href === void 0 ? "" : _href, rounded = param.rounded, closeBtn = param.closeBtn, className = param.className, style = param.style, nofollow = param.nofollow, target = param.target;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.u)();
    var ref14 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true), visible = ref14[0], setVisible = ref14[1];
    var ref15;
    var tagStyle = /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("display:flex;align-items:center;font-size:", (ref = theme.fontSize) === null || ref === void 0 ? void 0 : ref.sm, ";", "" /* border: 1px solid ${ theme.colors.secGray}; */ , "        max-width:max-content;border-radius:", rounded ? (ref1 = theme.borderRadius) === null || ref1 === void 0 ? void 0 : ref1.full : (ref2 = theme.borderRadius) === null || ref2 === void 0 ? void 0 : ref2.default, ";padding:", (ref3 = theme.spacing) === null || ref3 === void 0 ? void 0 : ref3.one, " ", (ref4 = theme.spacing) === null || ref4 === void 0 ? void 0 : ref4.three, ";color:", (ref5 = theme.colors) === null || ref5 === void 0 ? void 0 : ref5.medGray, ";background-color:", (ref6 = theme.colors) === null || ref6 === void 0 ? void 0 : ref6.lighterGray, ";&:hover{", "" /* border-color: ${theme.colors.medGray}; */ , "            cursor:pointer;background-color:", (ref7 = theme.colors) === null || ref7 === void 0 ? void 0 : ref7.lightGray, ";a{color:", (ref15 = (ref8 = theme.colors) === null || ref8 === void 0 ? void 0 : ref8.text) !== null && ref15 !== void 0 ? ref15 : "", ";}}span.close{color:", (ref9 = theme.colors) === null || ref9 === void 0 ? void 0 : ref9.secGray, ";font-size:", (ref10 = theme.fontSize) === null || ref10 === void 0 ? void 0 : ref10.lg, ";&:hover{color:", (ref11 = theme.colors) === null || ref11 === void 0 ? void 0 : ref11.medGray, ";}}", className, " ", style);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .Fragment */ .HY, {
        children: visible && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("div", {
            className: "tag",
            css: tagStyle,
            children: [
                href && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(___WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rU, {
                    href: href,
                    color: (ref12 = theme.colors) === null || ref12 === void 0 ? void 0 : ref12.medGray,
                    rel: nofollow ? "nofollow" : "follow",
                    target: target,
                    children: children
                }),
                !href && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
                    color: (ref13 = theme.colors) === null || ref13 === void 0 ? void 0 : ref13.medGray,
                    children: children
                }),
                closeBtn && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("span", {
                    className: "close relative",
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(react_icons_io__WEBPACK_IMPORTED_MODULE_5__/* .IoIosCloseCircle */ .FMH, {
                        className: "inline-block mr-2",
                        onClick: function() {
                            return setVisible(false);
                        }
                    })
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Tag);


/***/ }),

/***/ 12774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "kJ": function() { return /* binding */ colorBack; },
/* harmony export */   "zP": function() { return /* binding */ MediaQuery; }
/* harmony export */ });
/* unused harmony exports ProfitOrLossCheck, currencyFormat */
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20442);



function MediaQuery(screen, measure) {
    var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_0__.u)();
    var bpSwitch = function(screenType) {
        switch(screenType){
            case "sm":
                var ref;
                return (ref = theme.screens) === null || ref === void 0 ? void 0 : ref.sm;
            case "md":
                var ref1;
                return (ref1 = theme.screens) === null || ref1 === void 0 ? void 0 : ref1.md;
            case "lg":
                var ref2;
                return (ref2 = theme.screens) === null || ref2 === void 0 ? void 0 : ref2.lg;
            case "xl":
                var ref3;
                return (ref3 = theme.screens) === null || ref3 === void 0 ? void 0 : ref3.xl;
            case "xxl":
                var ref4;
                return (ref4 = theme.screens) === null || ref4 === void 0 ? void 0 : ref4.xxl;
        }
    };
    return "@media (".concat(measure, "-width: ").concat(bpSwitch(screen), ")");
}
function ProfitOrLossCheck(param) {
    var percentage = param.percentage, background = param.background;
    percentage = "".concat(percentage);
    return /*#__PURE__*/ _jsxs("span", {
        css: function(theme) {
            var ref, ref1, ref2, ref3, ref4, ref5;
            return /*#__PURE__*/ css(background ? "background-color: ".concat(percentage.charAt(0) == "-" ? (ref = theme.colors) === null || ref === void 0 ? void 0 : ref.danger : (ref1 = theme.colors) === null || ref1 === void 0 ? void 0 : ref1.success, ";\n                    color: ").concat((ref2 = theme.colors) === null || ref2 === void 0 ? void 0 : ref2.white, ";\n                    border-radius: ").concat((ref3 = theme.borderRadius) === null || ref3 === void 0 ? void 0 : ref3.full, ";\n                    justify-content: center;\n                    align-items: center;\n                    display: flex;\n                    ", "\n                    height: 3.5rem;\n                    width: 3.5rem;\n                    flex-direction: column;\n\n                    ") : "color: ".concat(percentage.charAt(0) == "-" ? (ref4 = theme.colors) === null || ref4 === void 0 ? void 0 : ref4.danger : (ref5 = theme.colors) === null || ref5 === void 0 ? void 0 : ref5.success, ";"));
        },
        children: [
            percentage.charAt(0) == "-" ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(BsArrowDownShort, {
                        className: "inline-block"
                    }),
                    percentage.replace("-", "")
                ]
            }) : /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(BsArrowUpShort, {
                        className: "inline-block"
                    }),
                    percentage
                ]
            }),
            "%"
        ]
    });
}
function currencyFormat(num, type, count) {
    return Intl.NumberFormat(count, {
        style: "currency",
        currency: type
    }).format(num);
}
function colorBack(colorName) {
    if ((colorName === null || colorName === void 0 ? void 0 : colorName.charAt(0)) === "#" || colorName === "transparent") {
        return colorName;
    }
    return false;
}


/***/ }),

/***/ 82843:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "UQ": function() { return /* reexport */ base_ui_Accordion; },
  "bO": function() { return /* reexport */ base_ui_AnimatedCircle; },
  "qE": function() { return /* reexport */ base_ui_Avatar; },
  "zx": function() { return /* reexport */ base_ui_Button; },
  "hE": function() { return /* reexport */ base_ui_ButtonGroup; },
  "Zb": function() { return /* reexport */ base_ui_Card; },
  "lr": function() { return /* reexport */ base_ui_Carousel; },
  "p8": function() { return /* reexport */ base_ui_CommentCard; },
  "iz": function() { return /* reexport */ base_ui_Divider; },
  "Lg": function() { return /* reexport */ base_ui_Fab; },
  "Ee": function() { return /* reexport */ base_ui_Image/* default */.Z; },
  "rU": function() { return /* reexport */ base_ui_Link; },
  "pU": function() { return /* reexport */ base_ui_Media; },
  "Vn": function() { return /* reexport */ base_ui_MegaMenu; },
  "v3": function() { return /* reexport */ base_ui_MenuBody; },
  "Ky": function() { return /* reexport */ base_ui_MessageCard; },
  "pz": function() { return /* reexport */ MiscCarousel; },
  "u_": function() { return /* reexport */ base_ui_Modal; },
  "Rq": function() { return /* reexport */ base_ui_PaginationNxtPrev; },
  "NZ": function() { return /* reexport */ base_ui_SectionTitle; },
  "Tz": function() { return /* reexport */ ShareButton; },
  "OK": function() { return /* reexport */ base_ui_Tab; },
  "x4": function() { return /* reexport */ base_ui_TabPanel; },
  "iA": function() { return /* reexport */ base_ui_Table; },
  "Vp": function() { return /* reexport */ Tag/* default */.Z; },
  "ZT": function() { return /* reexport */ base_ui_Typography; },
  "nk": function() { return /* reexport */ base_ui_Video; }
});

// UNUSED EXPORTS: Pagination, PartnerLogo, SimplePagination, Svg, TableCoins

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./src/features/base-ui/Svg.jsx
/* eslint-disable @next/next/no-img-element */ 



function Svg(param) {
    var src = param.src, color = param.color, className = param.className;
    if (src.includes("/api/storage")) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            className: className,
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:inline-block;& svg{width:100%;height:100%;}"),
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                alt: "",
                src: src
            })
        });
    } else {
        if (color) {
            var match = src.match(/fill="\w{18}"/);
            if (match) {
                src = src.replace(new RegExp(match[0]), "");
            }
            src = src.replace(/<svg/, '<svg fill="'.concat(color, '"'));
        }
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            className: className,
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:inline-block;& svg{width:100%;height:100%;}"),
            dangerouslySetInnerHTML: {
                __html: src
            }
        });
    }
}
Svg.propTypes = {
    src: (prop_types_default()).string.isRequired,
    color: (prop_types_default()).string
};
/* harmony default export */ var base_ui_Svg = ((/* unused pure expression or super */ null && (Svg)));

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var src_tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var dist_clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./src/features/base-ui/Utility.js
var Utility = __webpack_require__(12774);
// EXTERNAL MODULE: ./config.json
var config = __webpack_require__(51181);
;// CONCATENATED MODULE: ./src/features/base-ui/Link.js




function _templateObject() {
    var data = (0,src_tagged_template_literal/* default */.Z)([
        "\n                    ",
        "\n                "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var Link_Link = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var children = _param.children, href = _param.href, onMouseOver = _param.onMouseOver, onMouseOut = _param.onMouseOut, _external = _param.external, external = _external === void 0 ? false : _external, target = _param.target, download = _param.download, className = _param.className, style = _param.style, color = _param.color, hoverColor = _param.hoverColor, onClick = _param.onClick, backgroundColor = _param.backgroundColor, rel = _param.rel, _nextPrefetch = _param.nextPrefetch, nextPrefetch = _nextPrefetch === void 0 ? false : _nextPrefetch, _nextHrefAs = _param.nextHrefAs, nextHrefAs = _nextHrefAs === void 0 ? null : _nextHrefAs, args = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "href",
        "onMouseOver",
        "onMouseOut",
        "external",
        "target",
        "download",
        "className",
        "style",
        "color",
        "hoverColor",
        "onClick",
        "backgroundColor",
        "rel",
        "nextPrefetch",
        "nextHrefAs"
    ]);
    var _$ref;
    if (((_$ref = config.settings) === null || _$ref === void 0 ? void 0 : _$ref.open_news_in_new_tab) === true) target = "_blank";
    /* eslint-disable indent */ var linkCss = function(theme) {
        var _$ref, _$ref1, _$ref2, _$ref3;
        return "\n                color: ".concat((0,Utility/* colorBack */.kJ)(color) || ((_$ref = theme.colors) === null || _$ref === void 0 ? void 0 : _$ref[color]) || ((_$ref1 = theme.colors) === null || _$ref1 === void 0 ? void 0 : _$ref1.medGray), "; \n                ").concat(backgroundColor ? "" : "&:hover {\n                            color: ".concat((0,Utility/* colorBack */.kJ)(hoverColor) || ((_$ref2 = theme.colors) === null || _$ref2 === void 0 ? void 0 : _$ref2[hoverColor]) || ((_$ref3 = theme.colors) === null || _$ref3 === void 0 ? void 0 : _$ref3.primary), ";\n                        }"), "   \n                cursor: pointer;\n                ");
    };
    var bgLink = function(theme) {
        var _$ref, _$ref1;
        return "\n                cursor: pointer;\n                ".concat(backgroundColor ? "background-color: ".concat((_$ref = theme.colors) === null || _$ref === void 0 ? void 0 : _$ref[backgroundColor], "; \n                &:hover {\n                        box-shadow: ").concat((_$ref1 = theme.boxShadow) === null || _$ref1 === void 0 ? void 0 : _$ref1.default, ";\n                }") : "", "\n                ").concat(className, "\n            ");
    };
    /* eslint-enable indent */ var linkBody = external === true ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
        className: "external-link",
        css: bgLink,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            href: href,
            download: download,
            target: target,
            css: linkCss,
            onClick: onClick,
            onMouseOver: onMouseOver,
            onMouseOut: onMouseOut,
            ref: ref,
            rel: rel
        }, args), {
            children: children
        }))
    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
        className: "internal-link",
        css: bgLink,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
            href: href,
            passHref: true,
            prefetch: nextPrefetch ? undefined : false,
            as: nextHrefAs,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                onClick: onClick,
                css: linkCss,
                ref: ref,
                onMouseOver: onMouseOver,
                onMouseOut: onMouseOut,
                rel: rel
            }, args), {
                target: target,
                children: children
            }))
        })
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: (0,dist_clsx/* default */.Z)("link inline-block", className),
        css: (0,emotion_react_browser_esm/* css */.iv)(_templateObject(), style),
        children: linkBody
    });
});
/* harmony default export */ var base_ui_Link = (Link_Link);

;// CONCATENATED MODULE: ./src/features/base-ui/Typography.js



//+++++++++++++++++++++++++++++++++++
//* font-weight numeric & named value
//* 100 Thin
//* 200 Extra Light
//* 300 Light
//* 400 Normal
//* 500 Medium
//* 600 Semi Bold
//* 700 Bold
//* 800 Extra Bold
//* 900 Ultra Bold
//++++++++++++++++++++++++++++++++++
//* font-size Heading giude
//* h1: 2.5rem
//* h2: 2.2rem
//* h3: 1.7rem
//* h4: 1.4rem
//* h5: 1.2rem
//* h6: 1.05rem
//++++++++++++++++++++++++++++++++++
//* line-height guide
//* default: 1.167
//* paragraph: 1.5
//++++++++++++++++++++++++++++++++++
//                            css={(theme) => ({color: theme.colors.medGray})}
function Typography_Typography(param) {
    var _type = param.type, type = _type === void 0 ? "t" : _type, children = param.children, color = param.color, fontWeight = param.fontWeight, lineHeight = param.lineHeight, _align = param.align, align = _align === void 0 ? "start" : _align, lineClamp = param.lineClamp, className = param.className, hoverColor = param.hoverColor, fontSize = param.fontSize, _transform = param.transform, transform = _transform === void 0 ? "none" : _transform, style = param.style;
    var fontWeightSwitch = function(weightName) {
        switch(weightName){
            case "Thin":
                return "100";
            case "Extra Light":
                return "200";
            case "Light":
                return "300";
            case "Normal":
                return "400";
            case "Medium":
                return "500";
            case "Semi Bold":
                return "600";
            case "Bold":
                return "700";
            case "Extra Bold":
                return "800";
            case "Ultra Bold":
                return "900";
        }
    };
    /* eslint-disable */ var typoCss = function(theme) {
        var ref, ref1, ref2, ref3, ref4;
        var ref5, ref6;
        var themeTypography = (ref6 = (ref5 = (ref = theme.typography) === null || ref === void 0 ? void 0 : ref[type]) !== null && ref5 !== void 0 ? ref5 : (ref1 = theme.typography) === null || ref1 === void 0 ? void 0 : ref1["t"]) !== null && ref6 !== void 0 ? ref6 : {};
        return "\n            margin-bottom: 0.35rem;\n            font-size: ".concat(fontSize || themeTypography.fontSize, ";\n            line-height: ").concat(lineHeight || themeTypography.lineHeight, ";\n            font-weight: ").concat(fontWeightSwitch(fontWeight) || themeTypography.fontWeight, ";\n            text-align: ").concat(align, ";\n            color: ").concat((0,Utility/* colorBack */.kJ)(color) || ((ref2 = theme.colors) === null || ref2 === void 0 ? void 0 : ref2[color]) || ((ref3 = theme.colors) === null || ref3 === void 0 ? void 0 : ref3.text), ";\n            overflow: ").concat(lineClamp ? "hidden" : "", ";\n            display: ").concat(lineClamp ? "-webkit-box" : "", ";\n            -webkit-box-orient: ").concat(lineClamp ? "vertical" : "", ";\n            -webkit-line-clamp: ").concat(lineClamp ? lineClamp : "", ";\n            ").concat(hoverColor && "&:hover {\n                    color: ".concat((ref4 = theme.colors) === null || ref4 === void 0 ? void 0 : ref4[hoverColor], ";\n                }"), ";\n            text-transform: ").concat(transform, ";\n            ").concat(style, ";\n\n            @media (max-width: 1024px) {\n                overflow: visible;\n                display: block;\n            }\n        ");
    };
    var typoCss2 = function(theme) {
        var ref, ref1, ref2;
        var ref3;
        var themeTypography = (ref3 = (ref = theme.typography) === null || ref === void 0 ? void 0 : ref[type]) !== null && ref3 !== void 0 ? ref3 : (ref1 = theme.typography) === null || ref1 === void 0 ? void 0 : ref1["t"];
        return "\n            margin: 10px 0;\n            font-size: 28px;\n            text-align: start;\n            color: ".concat(color !== null && color !== void 0 ? color : "rgb(0, 0, 0)", ";\n            overflow: ").concat(lineClamp ? "hidden" : "", ";\n            display: ").concat(lineClamp ? "-webkit-box" : "", ";\n            -webkit-box-orient: ").concat(lineClamp ? "vertical" : "", ";\n            -webkit-line-clamp: ").concat(lineClamp ? lineClamp : "", ";\n            ").concat(hoverColor && "&:hover {\n                    color: ".concat((ref2 = theme.colors) === null || ref2 === void 0 ? void 0 : ref2[hoverColor], ";\n                }"), ";\n            text-transform: ").concat(transform, ";\n            ").concat(style, ";\n\n            @media (max-width: 1024px) {\n                overflow: visible;\n                display: block;\n            }\n        ");
    };
    /* eslint-enable */ var typoSwitch = function(hType) {
        switch(hType){
            case "h1":
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
                    className: (0,dist_clsx/* default */.Z)("typography h1", className),
                    css: typoCss2,
                    children: children
                });
            case "h2":
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
                    className: (0,dist_clsx/* default */.Z)("typography h2", className),
                    css: typoCss,
                    children: children
                });
            case "h3":
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", {
                    className: (0,dist_clsx/* default */.Z)("typography h3", className),
                    css: typoCss,
                    children: children
                });
            case "h4":
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h4", {
                    className: (0,dist_clsx/* default */.Z)("typography h4", className),
                    css: typoCss,
                    children: children
                });
            case "h5":
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h5", {
                    className: (0,dist_clsx/* default */.Z)("typography h5", className),
                    css: typoCss,
                    children: children
                });
            case "h6":
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h6", {
                    className: (0,dist_clsx/* default */.Z)("typography h6", className),
                    css: typoCss,
                    children: children
                });
            case "p":
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                    className: (0,dist_clsx/* default */.Z)("typography p", className),
                    css: typoCss,
                    children: children
                });
            case "t":
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                    className: (0,dist_clsx/* default */.Z)("typography t", className),
                    css: typoCss,
                    children: children
                });
            case "div":
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    className: (0,dist_clsx/* default */.Z)("typography", className),
                    css: typoCss,
                    children: children
                });
        }
    };
    return typoSwitch(type);
}
/* harmony default export */ var base_ui_Typography = (Typography_Typography);

// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-element-f0de968e.browser.esm.js + 1 modules
var emotion_element_f0de968e_browser_esm = __webpack_require__(20442);
// EXTERNAL MODULE: ./src/features/base-ui/Image.js
var base_ui_Image = __webpack_require__(94477);
// EXTERNAL MODULE: ./node_modules/react-icons/io/index.esm.js
var index_esm = __webpack_require__(51649);
// EXTERNAL MODULE: ./node_modules/react-icons/io5/index.esm.js
var io5_index_esm = __webpack_require__(60155);
;// CONCATENATED MODULE: ./src/features/base-ui/Card.js








function imageSizeSwitch(size) {
    switch(size){
        case "narrow":
            return "30%";
        case "wide":
            return "100%";
        case "normal":
            return "60%";
        default:
            return "60%";
    }
}
function switchBorderStyle(style, theme) {
    switch(style){
        case "rounded":
            var ref;
            return (ref = theme.borderRadius) === null || ref === void 0 ? void 0 : ref.default;
        case "square":
            return "0";
    }
}
function paddingSwitch(space, theme) {
    var spacing = theme.spacing;
    switch(space){
        case "xs":
            return spacing === null || spacing === void 0 ? void 0 : spacing.one;
        case "sm":
            return spacing === null || spacing === void 0 ? void 0 : spacing.two;
        case "md":
            return spacing === null || spacing === void 0 ? void 0 : spacing.four;
        case "lg":
            return spacing === null || spacing === void 0 ? void 0 : spacing.six;
        case "xl":
            return spacing === null || spacing === void 0 ? void 0 : spacing.eight;
        case "xxl":
            return spacing === null || spacing === void 0 ? void 0 : spacing.ten;
        default:
            return spacing === null || spacing === void 0 ? void 0 : spacing.six;
    }
}
function Card_Card(param) {
    var _type = param.type, type = _type === void 0 ? "default" : _type, _align = param.align, align = _align === void 0 ? "start" : _align, header = param.header, onMouseOver = param.onMouseOver, onMouseOut = param.onMouseOut, href = param.href, mediaType = param.mediaType, videoSrc = param.videoSrc, imgSrc = param.imgSrc, _imgAlt = param.imgAlt, imgAlt = _imgAlt === void 0 ? "alt" : _imgAlt, _imgWidth = param.imgWidth, imgWidth = _imgWidth === void 0 ? "1200px" : _imgWidth, _imgHeight = param.imgHeight, imgHeight = _imgHeight === void 0 ? "600px" : _imgHeight, _borderStyle = param.borderStyle, borderStyle = _borderStyle === void 0 ? "rounded" : _borderStyle, color = param.color, _height = param.height, height = _height === void 0 ? "auto" : _height, subtitle = param.subtitle, imgLayout = param.imgLayout, horizentalImageSize = param.horizentalImageSize, title = param.title, _imgFullRound = param.imgFullRound, imgFullRound = _imgFullRound === void 0 ? false : _imgFullRound, children = param.children, bordered = param.bordered, className = param.className, shadow = param.shadow, _spacing = param.spacing, spacing = _spacing === void 0 ? "lg" : _spacing, footer = param.footer, style = param.style;
    var ref, ref1;
    var theme = (0,emotion_element_f0de968e_browser_esm.u)();
    var mainStyle = "\n        background-color: ".concat(color || ((ref = theme.colors) === null || ref === void 0 ? void 0 : ref.white), ";\n        ").concat(shadow && "box-shadow: ".concat((ref1 = theme.boxShadow) === null || ref1 === void 0 ? void 0 : ref1.default), ";\n        border-radius: ").concat(switchBorderStyle(borderStyle, theme), ";\n        ").concat(bordered && "border: 1px solid #dbdbdb", ";\n        height: ").concat(height, ";\n        ").concat(style, ";\n    ");
    var mediaTypeStyle = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("background-color:#ffffff;position:absolute;z-index:9;display:flex;padding:0.25rem 0.5rem;", type === "default" && "top: -3rem;", " ", type === "horizental" && "top: 1rem;", "        align-items:center;gap:0.5rem;", type === "default" && "right: 0;");
    var videoTag = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
        css: mediaTypeStyle,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* IoLogoYoutube */.tPx, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                children: "ویدیو"
            })
        ]
    });
    var audioTag = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
        css: mediaTypeStyle,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(io5_index_esm/* IoMusicalNotes */.oV9, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                children: "صوتی"
            })
        ]
    });
    var inner = null;
    if (type === "default") {
        inner = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            className: (0,dist_clsx/* default */.Z)("card default-card vertical-card relative", className),
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:column;", mainStyle),
            onMouseOver: onMouseOver,
            onMouseOut: onMouseOut,
            children: [
                header && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    className: "py-2 header",
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:center;padding:", paddingSwitch(spacing, theme), " ", paddingSwitch(spacing, theme), " 0\n                                ", paddingSwitch(spacing, theme), ";"),
                    children: header
                }),
                imgSrc && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui_Image/* default */.Z, {
                    noStyle: true,
                    priority: true,
                    src: imgSrc,
                    alt: imgAlt,
                    width: imgWidth,
                    height: imgHeight,
                    layout: imgLayout || "responsive",
                    objectFit: "cover",
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("object-fit:cover;", imgFullRound && (header ? "border-radius: 0;" : /* eslint-disable indent */ "border-radius: ".concat(switchBorderStyle(borderStyle, theme), ";")), ";", !imgFullRound && (header ? "border-top-left-radius: 0; border-top-right-radius: 0;" : /* eslint-disable indent */ "border-top-left-radius:".concat(switchBorderStyle(borderStyle, theme), "; \n                              border-top-right-radius:").concat(switchBorderStyle(borderStyle, theme), ";")), ";/* eslint-enable indent */")
                }),
                videoSrc && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("video", {
                    muted: true,
                    loop: true,
                    controls: true,
                    preload: "metadata",
                    width: imgWidth,
                    height: imgHeight,
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("object-fit:cover;", imgFullRound && (header ? "border-radius: 0;" : /* eslint-disable indent */ "border-radius: ".concat(switchBorderStyle(borderStyle, theme), ";")), ";", !imgFullRound && (header ? "border-top-left-radius: 0; border-top-right-radius: 0;" : /* eslint-disable indent */ "border-top-left-radius:".concat(switchBorderStyle(borderStyle, theme), "; \n                          border-top-right-radius:").concat(switchBorderStyle(borderStyle, theme), ";")), ";/* eslint-enable indent */"),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
                        src: "".concat(videoSrc, "#t=0.5")
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    className: "md:container card-body relative",
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:", paddingSwitch(spacing, theme), ";flex:1;", "" /* height: 100%; */ ),
                    children: [
                        mediaType === "video" && videoTag,
                        mediaType === "audio" && audioTag,
                        subtitle && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            className: "card-subtitle",
                            children: subtitle
                        }),
                        title && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            className: "card-title mt-2 mb-4",
                            children: title
                        }),
                        children && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            className: "card-content",
                            children: children
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    className: "w-full",
                    children: footer && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        className: "card-footer",
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("" /* margin-top: 10px; */ , "                                display:flex;padding:0 ", paddingSwitch(spacing, theme), ";"),
                        children: footer
                    })
                })
            ]
        });
    } else if (type === "horizental") {
        inner = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            className: (0,dist_clsx/* default */.Z)("card horizental-card", className),
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;height:100%;", align === "start" && "flex-direction: row", ";", align === "end" && "flex-direction: row-reverse", ";", mainStyle),
            onMouseOver: onMouseOver,
            onMouseOut: onMouseOut,
            children: [
                (imgSrc || videoSrc) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    className: "card-image",
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:", imageSizeSwitch(horizentalImageSize), ";position:relative;", (0,Utility/* MediaQuery */.zP)("sm", "max"), "{width:70%;}"),
                    children: [
                        mediaType === "video" && videoTag,
                        mediaType === "audio" && audioTag,
                        imgSrc && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui_Image/* default */.Z, {
                            noStyle: true,
                            priority: true,
                            src: imgSrc,
                            width: imgWidth,
                            height: imgWidth,
                            alt: imgAlt,
                            layout: "fill",
                            objectFit: "cover",
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("object-fit:cover;", !imgFullRound && align === "start" && "border-top-right-radius: ".concat(switchBorderStyle(borderStyle, theme), ";\n                border-bottom-right-radius: ").concat(switchBorderStyle(borderStyle, theme), ";"), ";", !imgFullRound && align === "end" && "border-top-left-radius: ".concat(switchBorderStyle(borderStyle, theme), ";\n                border-bottom-left-radius: ").concat(switchBorderStyle(borderStyle, theme), ";"), " ", imgFullRound && "border-radius: ".concat(switchBorderStyle(borderStyle, theme), ";"), ";")
                        }),
                        videoSrc && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("video", {
                            muted: true,
                            loop: true,
                            controls: true,
                            preload: "metadata",
                            width: imgWidth,
                            height: imgWidth,
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("object-fit:cover;", !imgFullRound && align === "start" && "border-top-right-radius: ".concat(switchBorderStyle(borderStyle, theme), ";\n        border-bottom-right-radius: ").concat(switchBorderStyle(borderStyle, theme), ";"), ";", !imgFullRound && align === "end" && "border-top-left-radius: ".concat(switchBorderStyle(borderStyle, theme), ";\n        border-bottom-left-radius: ").concat(switchBorderStyle(borderStyle, theme), ";"), " ", imgFullRound && "border-radius: ".concat(switchBorderStyle(borderStyle, theme), ";"), ";"),
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
                                src: "".concat(videoSrc, "#t=0.5")
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    className: "md:container w-full card-body",
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:", paddingSwitch(spacing, theme), ";display:flex;flex-direction:column;height:100%;"),
                    children: [
                        subtitle && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            className: "card-subtitle",
                            children: subtitle
                        }),
                        title && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            className: "card-title pt-1 mb-4",
                            children: title
                        }),
                        children && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            className: "card-content",
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("flex:1;align-self:start;"),
                            children: children
                        }),
                        footer && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            className: "card-footer",
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:10px;display:flex;"),
                            children: footer
                        })
                    ]
                })
            ]
        });
    }
    if (href) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: href,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
            children: inner
        })
    });
    return inner;
}
/* harmony default export */ var base_ui_Card = (Card_Card);

;// CONCATENATED MODULE: ./src/features/base-ui/Button.js



function Button_templateObject() {
    var data = (0,src_tagged_template_literal/* default */.Z)([
        "\n            display: flex;\n            align-items: center;\n            border-radius: ",
        ";\n            ",
        "\n            background-color: ",
        ";\n            color: ",
        ";\n            ",
        "\n            ",
        "\n            ",
        "\n        "
    ]);
    Button_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var Button_Button = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var icon = param.icon, href = param.href, children = param.children, target = param.target, onClick = param.onClick, download = param.download, type = param.type, color = param.color, _external = param.external, external = _external === void 0 ? true : _external, hoverColor = param.hoverColor, rounded = param.rounded, size = param.size, className = param.className, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, backgroundColor = param.backgroundColor, style = param.style;
    var _$ref, _$ref1, _$ref2, _$ref3, _$ref4, _$ref5, _$ref6;
    var theme = (0,emotion_element_f0de968e_browser_esm.u)();
    var linkButtonstyle = "\n            display: flex; \n            align-items: center; \n            border-radius: ".concat(rounded || ((_$ref = theme.borderRadius) === null || _$ref === void 0 ? void 0 : _$ref.sm), ";\n            background-color: ").concat((_$ref1 = theme.colors) === null || _$ref1 === void 0 ? void 0 : _$ref1[hoverColor], ";\n        ");
    var buttonSize = function(bSize) {
        switch(bSize){
            case "x-small":
                var _$ref, _$ref1;
                return "\n                    font-size: ".concat((_$ref = theme.fontSize) === null || _$ref === void 0 ? void 0 : _$ref.xs, ";\n                    padding: ").concat((_$ref1 = theme.spacing) === null || _$ref1 === void 0 ? void 0 : _$ref1.one, ";\n                ");
            case "small":
                var _$ref2, _$ref3;
                return "\n                    font-size: ".concat((_$ref2 = theme.fontSize) === null || _$ref2 === void 0 ? void 0 : _$ref2.sm, ";\n                    padding: ").concat((_$ref3 = theme.spacing) === null || _$ref3 === void 0 ? void 0 : _$ref3.one, ";\n                ");
            case "medium":
                var _$ref4, _$ref5, _$ref6, _$ref7;
                return "font-size: ".concat((_$ref4 = theme.fontSize) === null || _$ref4 === void 0 ? void 0 : _$ref4.base, "; ").concat(type === "link" ? "padding: ".concat((_$ref5 = theme.spacing) === null || _$ref5 === void 0 ? void 0 : _$ref5.two, ";") : "padding: ".concat((_$ref6 = theme.spacing) === null || _$ref6 === void 0 ? void 0 : _$ref6.one, " ").concat((_$ref7 = theme.spacing) === null || _$ref7 === void 0 ? void 0 : _$ref7.two, ";"), ";\n                    ");
            case "large":
                var _$ref8, _$ref9, _$ref10, _$ref11;
                return "font-size: ".concat((_$ref8 = theme.fontSize) === null || _$ref8 === void 0 ? void 0 : _$ref8.lg, "; ").concat(type === "link" ? "padding: ".concat((_$ref9 = theme.spacing) === null || _$ref9 === void 0 ? void 0 : _$ref9.three, ";") : "padding: ".concat((_$ref10 = theme.spacing) === null || _$ref10 === void 0 ? void 0 : _$ref10.four, " ").concat((_$ref11 = theme.spacing) === null || _$ref11 === void 0 ? void 0 : _$ref11.five, ";"), ";");
            default:
                var _$ref12, _$ref13, _$ref14, _$ref15;
                return "font-size: ".concat((_$ref12 = theme.fontSize) === null || _$ref12 === void 0 ? void 0 : _$ref12.base, "; ").concat(type === "link" ? "padding: ".concat((_$ref13 = theme.spacing) === null || _$ref13 === void 0 ? void 0 : _$ref13.two, ";") : "padding: ".concat((_$ref14 = theme.spacing) === null || _$ref14 === void 0 ? void 0 : _$ref14.one, " ").concat((_$ref15 = theme.spacing) === null || _$ref15 === void 0 ? void 0 : _$ref15.two, ";"), ";\n            \n                    ");
        }
    };
    var buttonStyle = (0,emotion_react_browser_esm/* css */.iv)(Button_templateObject(), (_$ref2 = theme.borderRadius) === null || _$ref2 === void 0 ? void 0 : _$ref2.default, buttonSize(size), (_$ref3 = theme.colors) === null || _$ref3 === void 0 ? void 0 : _$ref3[backgroundColor], (_$ref4 = theme.colors) === null || _$ref4 === void 0 ? void 0 : _$ref4[color], disabled && "filter: contrast(40%);", !disabled && "&:hover {\n                box-shadow: ".concat((_$ref5 = theme.boxShadow) === null || _$ref5 === void 0 ? void 0 : _$ref5.default, ";\n                ").concat(hoverColor ? "background-color: ".concat((_$ref6 = theme.colors) === null || _$ref6 === void 0 ? void 0 : _$ref6[hoverColor], ";") : "", "\n                filter: contrast(120%);\n            }"), style);
    var sharedProps = {
        href: !disabled ? href : null,
        disabled: disabled,
        onClick: onClick
    };
    var linkBody = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            children && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                className: "mx-1",
                children: children
            }),
            icon && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                className: "mx-1",
                children: icon
            })
        ]
    });
    if (type === "link") return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui_Link, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sharedProps), {
        external: external,
        hoverColor: hoverColor,
        className: (0,dist_clsx/* default */.Z)("", className, buttonSize(size)),
        ref: ref,
        children: linkBody
    }));
    if (type === "linkButton") return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui_Link, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sharedProps), {
        external: external,
        className: (0,dist_clsx/* default */.Z)("link-button", className, linkButtonstyle, buttonSize(size)),
        download: download,
        target: target,
        backgroundColor: backgroundColor,
        color: color,
        ref: ref,
        children: linkBody
    }));
    if (type === "submit") return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sharedProps), {
        className: (0,dist_clsx/* default */.Z)("submit cursor-pointer", className),
        css: buttonStyle,
        value: children,
        type: "submit",
        ref: ref
    }));
    //{clsx('link inline-block', className)}
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sharedProps), {
        className: (0,dist_clsx/* default */.Z)("button", className),
        css: buttonStyle,
        ref: ref,
        children: linkBody
    }));
});
/* harmony default export */ var base_ui_Button = (Button_Button);

;// CONCATENATED MODULE: ./src/features/base-ui/Avatar.js





function Avatar(param) {
    var children = param.children, size = param.size, _imgSrc = param.imgSrc, imgSrc = _imgSrc === void 0 ? "/img/shared/avatar.gif" : _imgSrc, alt = param.alt, _isImg = param.isImg, isImg = _isImg === void 0 ? true : _isImg, _rounded = param.rounded, rounded = _rounded === void 0 ? true : _rounded, _color = param.color, color = _color === void 0 ? "white" : _color, _bgColor = param.bgColor, bgColor = _bgColor === void 0 ? "danger" : _bgColor, fontSize = param.fontSize, boxSize = param.boxSize, style = param.style;
    var ref, ref1;
    var theme = (0,emotion_element_f0de968e_browser_esm.u)();
    //TODO make into switch
    var tSize = "";
    if (size === "medium") {
        size = "40px";
        tSize = "1.2rem";
    } else if (size === "small") {
        size = "24px";
        tSize = "0.8rem";
    } else if (size === "large") {
        size = "56px";
        tSize = "1.8rem";
    } else if (fontSize || boxSize) {
        size = boxSize;
        tSize = fontSize;
    }
    var _ref = style !== null && style !== void 0 ? style : {}, objectFit = _ref.objectFit, otherStyles = (0,_object_without_properties/* default */.Z)(_ref, [
        "objectFit"
    ]);
    if (isImg) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui_Image/* default */.Z, {
        noStyle: true,
        src: imgSrc,
        alt: alt,
        width: size,
        height: size,
        objectFit: objectFit,
        style: (0,_object_spread/* default */.Z)({
            borderRadius: rounded ? "100px" : "2px"
        }, otherStyles)
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:", size, ";height:", size, ";overflow:hidden;display:flex;background-color:", (ref = theme.colors) === null || ref === void 0 ? void 0 : ref[bgColor], ";color:", (ref1 = theme.colors) === null || ref1 === void 0 ? void 0 : ref1[color], ";justify-content:center;align-items:center;font-size:", tSize, ";padding:0;", rounded === true ? "border-radius: 100px" : "border-radius: 2px", ";"),
        children: children
    });
}
/* harmony default export */ var base_ui_Avatar = (Avatar);

;// CONCATENATED MODULE: ./src/features/base-ui/Table.js



function Table_Table(param) {
    var className = param.className, head = param.head, children = param.children, style = param.style;
    var tableCss = function(theme) {
        var ref, ref1, ref2, ref3;
        var radius = (ref = theme.borderRadius) === null || ref === void 0 ? void 0 : ref.xl;
        var white = (ref1 = theme.colors) === null || ref1 === void 0 ? void 0 : ref1.white;
        var primary = (ref2 = theme.colors) === null || ref2 === void 0 ? void 0 : ref2.primary;
        var lighterGray = (ref3 = theme.colors) === null || ref3 === void 0 ? void 0 : ref3.lighterGray;
        return "\n            background: ".concat(white, ";\n            border-radius: ").concat(radius, ";\n            th {\n                padding: 15px;\n                text-align: center;\n            }\n            td {\n                padding: 15px 5px 15px 5px;\n                text-align: center;\n            }\n            th:first-of-type {\n                border-top-right-radius: ").concat(radius, ";\n                text-align: start;\n                padding-right: 1.5rem;\n\n            }\n            th {\n                position: relative;\n            }\n            th:last-child {\n                border-top-left-radius: ").concat(radius, ";\n            }\n            thead {\n                color: ").concat(primary, ";\n                outline-offset: -1px;\n                border-top-left-radius: ").concat(radius, ";\n                border-top-right-radius: ").concat(radius, ";\n                outline: 1px solid ").concat(lighterGray, ";\n                // background-color: ").concat(white, ";\n\n            }\n            tbody {\n                outline: 1px solid ").concat(lighterGray, ";\n                outline-offset: -1px;\n                border-bottom-left-radius: ").concat(radius, ";\n                border-bottom-right-radius: ").concat(radius, ";\n                -moz-outline-radius: ").concat(radius, ";\n            }\n            tr {\n                border-bottom: 1px solid ").concat(lighterGray, ";\n            }\n            tr:last-child {\n                border-bottom: none;\n            }\n            tr:last-child {\n                td:first-of-type {\n                    border-bottom-right-radius: ").concat(radius, ";\n                }\n                td:last-child {\n                    border-bottom-left-radius: ").concat(radius, ";\n                }\n            }\n            ").concat(style, "\n       \n        ");
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: (0,dist_clsx/* default */.Z)("w-full", className),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("table", {
            className: "w-full",
            css: tableCss,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("thead", {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tr", {
                        children: head.map(function(item, idx) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("th", {
                                children: item
                            }, idx);
                        })
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tbody", {
                    children: children
                })
            ]
        })
    });
}
/* harmony default export */ var base_ui_Table = (Table_Table);

// EXTERNAL MODULE: ./src/features/base-ui/Tag.jsx
var Tag = __webpack_require__(85887);
;// CONCATENATED MODULE: ./src/features/base-ui/Tab.js





function Tab(param) {
    var tabs = param.tabs, children = param.children, justify = param.justify, onTabChange = param.onTabChange, style = param.style, _hideHeader = param.hideHeader, hideHeader = _hideHeader === void 0 ? false : _hideHeader;
    var ref = (0,react.useState)(0), activeTab = ref[0], setActiveTab = ref[1];
    var activeColor = "primary";
    var firstColor = "lighter";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(style),
        className: "tabs flex flex-wrap justify-".concat(justify),
        children: [
            !hideHeader && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui_ButtonGroup, {
                color: "white",
                children: tabs.map(function(item, idx) {
                    /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui_Button, {
                            onClick: function() {
                                setActiveTab(idx);
                                onTabChange === null || onTabChange === void 0 ? void 0 : onTabChange(tabs[idx], idx);
                            },
                            backgroundColor: idx === activeTab ? activeColor : firstColor,
                            className: (0,dist_clsx/* default */.Z)("p-4", idx === activeTab && "active-button"),
                            children: item.label
                        })
                    }, idx);
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "w-full tab-content basis-full pt-6",
                children: children[activeTab]
            })
        ]
    });
}
/* harmony default export */ var base_ui_Tab = (Tab);

;// CONCATENATED MODULE: ./src/features/base-ui/TabPanel.js



function TabPanel(param) {
    var children = param.children, index = param.index, style = param.style;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(style),
        className: "tab-panel",
        index: index,
        children: children
    });
}
/* harmony default export */ var base_ui_TabPanel = (TabPanel);

;// CONCATENATED MODULE: ./src/features/base-ui/ButtonGroup.js




function ButtonGroup(param) {
    var children = param.children, backgroundColor = param.backgroundColor, color = param.color, style = param.style;
    var ref, ref1, ref2;
    var theme = (0,emotion_element_f0de968e_browser_esm.u)();
    var borderRadius = theme.borderRadius.lg;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: "button-group",
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;button{border-radius:0;background-color:", (ref = theme.colors) === null || ref === void 0 ? void 0 : ref[backgroundColor], ";border-left:1px solid ", (ref1 = theme.colors) === null || ref1 === void 0 ? void 0 : ref1[color], ";color:", (ref2 = theme.colors) === null || ref2 === void 0 ? void 0 : ref2[color], ";}div:last-child{button{border-start-end-radius:", borderRadius, ";border-end-end-radius:", borderRadius, ";border-left:none;}}div:first-of-type{button{border-start-start-radius:", borderRadius, ";border-end-start-radius:", borderRadius, ";}}", (0,Utility/* MediaQuery */.zP)("md", "max"), "{flex-wrap:wrap;justify-content:center;div{padding:0.125rem;button{border-radius:", borderRadius, ";}}}", style),
        children: children
    });
}
/* harmony default export */ var base_ui_ButtonGroup = (ButtonGroup);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/keen-slider/keen-slider.min.css
var keen_slider_min = __webpack_require__(19409);
// EXTERNAL MODULE: ./node_modules/keen-slider/react.js
var keen_slider_react = __webpack_require__(82730);
// EXTERNAL MODULE: ./node_modules/react-icons/bs/index.esm.js
var bs_index_esm = __webpack_require__(63750);
;// CONCATENATED MODULE: ./src/features/base-ui/Carousel.js





 // import from 'keen-slider/react.es' for to get an ES module


function Carousel(param) {
    var children = param.children, _rtl = param.rtl, rtl = _rtl === void 0 ? false : _rtl, _loop = param.loop, loop = _loop === void 0 ? true : _loop, _preview = param.preview, preview = _preview === void 0 ? {
        sm: 1,
        md: 2,
        lg: 4,
        xl: 6,
        xxl: 7
    } : _preview, _controls = param.controls, controls = _controls === void 0 ? true : _controls, _dots = param.dots, dots = _dots === void 0 ? false : _dots, _vertical = param.vertical, vertical = _vertical === void 0 ? false : _vertical, _autoSwitch = param.autoSwitch, autoSwitch = _autoSwitch === void 0 ? false : _autoSwitch, _switchTime = param.switchTime, switchTime = _switchTime === void 0 ? 5000 : _switchTime, style = param.style, _icon = param.icon, icon = _icon === void 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(bs_index_esm/* BsCircle */.b9R, {}) : _icon, className = param.className;
    var ref, ref1, ref2, ref3;
    var autoplay = (0,react.useCallback)(function(slider) {
        var clearNextTimeout = function clearNextTimeout() {
            clearTimeout(timeout);
        };
        var nextTimeout = function nextTimeout() {
            clearTimeout(timeout);
            if (mouseOver) return;
            timeout = setTimeout(function() {
                slider === null || slider === void 0 ? void 0 : slider.next();
            }, switchTime);
        };
        if (!slider) return;
        var timeout;
        var mouseOver = false;
        slider.on("created", function() {
            slider.container.addEventListener("mouseover", function() {
                mouseOver = true;
                clearNextTimeout();
            });
            slider.container.addEventListener("mouseout", function() {
                mouseOver = false;
                nextTimeout();
            });
            nextTimeout();
        });
        slider.on("dragStarted", clearNextTimeout);
        slider.on("animationEnded", nextTimeout);
        slider.on("updated", nextTimeout);
    }, [
        switchTime
    ]);
    var plugins = autoSwitch ? autoplay : function() {};
    var ref4 = (0,_sliced_to_array/* default */.Z)(react.useState(0), 2), currentSlide = ref4[0], setCurrentSlide = ref4[1];
    var ref5 = (0,react.useState)(false), loaded = ref5[0], setLoaded = ref5[1];
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,keen_slider_react/* useKeenSlider */.E)({
        slideChanged: function slideChanged(slider) {
            setCurrentSlide(slider.track.details.rel);
        },
        created: function created() {
            setLoaded(true);
        },
        rtl: rtl,
        vertical: vertical,
        loop: loop,
        breakpoints: {
            "(min-width: 640px)": {
                slides: {
                    perView: preview.md,
                    spacing: 5
                }
            },
            "(min-width: 1024px)": {
                slides: {
                    perView: preview.lg,
                    spacing: 15
                }
            },
            "(min-width: 1280px)": {
                slides: {
                    perView: preview.xl,
                    spacing: 15
                }
            },
            "(min-width: 1580px)": {
                slides: {
                    perView: preview.xxl,
                    spacing: 15
                }
            }
        },
        slides: {
            perView: preview.sm
        }
    }, [
        // add plugins here
        plugins, 
    ]), 2), refCallback = ref6[0], instanceRef = ref6[1];
    (0,react.useEffect)(function() {
        var ref;
        instanceRef === null || instanceRef === void 0 ? void 0 : (ref = instanceRef.current) === null || ref === void 0 ? void 0 : ref.update();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        children
    ]);
    var ref7;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:relative;", style),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:relative;"),
                className: className,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        ref: refCallback,
                        className: "keen-slider",
                        children: children
                    }),
                    controls && loaded && instanceRef.current && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Arrow, {
                                left: true,
                                onClick: function(e) {
                                    var ref;
                                    return e.stopPropagation() || ((ref = instanceRef.current) === null || ref === void 0 ? void 0 : ref.next());
                                },
                                disabled: currentSlide === 0,
                                arrowStyle: "left:0; top:0; margin:auto; height:100%; cursor:pointer; position:absolute; background: linear-gradient(to left, transparent, 10%, white); border-right: 1px solid #ffffff;"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Arrow, {
                                onClick: function(e) {
                                    var ref;
                                    return e.stopPropagation() || ((ref = instanceRef.current) === null || ref === void 0 ? void 0 : ref.prev());
                                },
                                disabled: currentSlide === ((ref = instanceRef.current.track.details) === null || ref === void 0 ? void 0 : ref.slides.length) - 1,
                                arrowStyle: "right:0; top:0; margin:auto; height:100%; cursor:pointer; position:absolute; background: linear-gradient(to right, transparent ,10%, white); border-left: 1px solid #ffffff;"
                            })
                        ]
                    })
                ]
            }),
            dots && loaded && instanceRef.current && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "dots",
                children: (0,_to_consumable_array/* default */.Z)(Array((ref7 = (ref1 = instanceRef.current.track) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.details) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.slides) === null || ref3 === void 0 ? void 0 : ref3.length) !== null && ref7 !== void 0 ? ref7 : 0).keys()).map(function(idx) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                        onClick: function() {
                            var ref;
                            (ref = instanceRef.current) === null || ref === void 0 ? void 0 : ref.moveToIdx(idx);
                        },
                        className: "dot" + (currentSlide === idx ? " active" : ""),
                        children: icon
                    }, idx);
                })
            })
        ]
    });
}
function Arrow(props) {
    var ref;
    var disabeld = props.disabled ? " arrow--disabled" : "";
    var theme = (0,emotion_element_f0de968e_browser_esm.u)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
        onClick: props.onClick,
        className: "arrow w-6 ".concat(props.className, " ").concat(props.left ? "arrow--left" : "arrow--right", " ").concat(disabeld),
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: (ref = theme.colors) === null || ref === void 0 ? void 0 : ref.secGray,
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(props.arrowStyle),
        children: [
            props.left && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z"
            }),
            !props.left && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z"
            })
        ]
    });
}
/* harmony default export */ var base_ui_Carousel = (Carousel);

;// CONCATENATED MODULE: ./src/features/base-ui/PartnerLogo.js





function PartnerLogo(param) {
    var src = param.src, caption = param.caption, _width = param.width, width = _width === void 0 ? 100 : _width, _height = param.height, height = _height === void 0 ? 100 : _height, _active = param.active, active = _active === void 0 ? false : _active;
    var colored = /*#__PURE__*/ css("background:linear-gradient(\n            45deg,#6366f1 0%,#a855f7 50%,#e74799 100%\n        );background-repeat:no-repeat;border-radius:100%;padding:3px;");
    var solid = /*#__PURE__*/ css("background-color:#eeeeee;border-radius:100%;padding:3px;");
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-col items-center text-center",
        children: [
            /*#__PURE__*/ _jsx("div", {
                css: active ? colored : solid,
                children: /*#__PURE__*/ _jsx("div", {
                    className: "rounded-full w-20 h-20 bg-white",
                    children: src && /*#__PURE__*/ _jsx("div", {
                        className: "p-1",
                        children: /*#__PURE__*/ _jsx(Image, {
                            noStyle: true,
                            alt: caption,
                            src: src,
                            width: width,
                            height: height
                        })
                    })
                })
            }),
            /*#__PURE__*/ _jsx(Typography, {
                type: "t",
                color: "medGray",
                className: "mt-4",
                children: caption
            })
        ]
    });
}
/* harmony default export */ var base_ui_PartnerLogo = ((/* unused pure expression or super */ null && (PartnerLogo)));

;// CONCATENATED MODULE: ./src/features/base-ui/Divider.js




function Divider(param) {
    var _orientation = param.orientation, orientation = _orientation === void 0 ? "horizental" : _orientation, tight = param.tight, width = param.width, className = param.className, gap = param.gap, color = param.color, _size = param.size, size = _size === void 0 ? "1px" : _size, _height = param.height, height = _height === void 0 ? "md" : _height, style = param.style;
    var paddingSwitch = function paddingSwitch(space) {
        var spacing = theme.spacing;
        switch(space){
            case "xs":
                return spacing === null || spacing === void 0 ? void 0 : spacing.one;
            case "sm":
                return spacing === null || spacing === void 0 ? void 0 : spacing.two;
            case "md":
                return spacing === null || spacing === void 0 ? void 0 : spacing.four;
            case "lg":
                return spacing === null || spacing === void 0 ? void 0 : spacing.six;
            case "xl":
                return spacing === null || spacing === void 0 ? void 0 : spacing.eight;
            case "xxl":
                return spacing === null || spacing === void 0 ? void 0 : spacing.ten;
            default:
                return spacing === null || spacing === void 0 ? void 0 : spacing.six;
        }
    };
    var ref;
    var theme = (0,emotion_element_f0de968e_browser_esm.u)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: orientation === "horizental" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("hr", {
            className: ("divider", (0,dist_clsx/* default */.Z)(className)),
            width: width,
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(!tight && "margin-top: ".concat(gap || paddingSwitch(height), ";\n                        margin-bottom: ").concat(gap || paddingSwitch(height), ";"), "                        display:block;border-top-width:", size, ";", color && "border-color: ".concat((ref = theme.colors) === null || ref === void 0 ? void 0 : ref[color]), ";width:", width, ";", style)
        })
    });
}
/* harmony default export */ var base_ui_Divider = (Divider);

;// CONCATENATED MODULE: ./src/features/base-ui/SectionTitle.js





function SectionTitle(param) {
    var children = param.children, _color = param.color, color = _color === void 0 ? "medGray" : _color, dividerColor = param.dividerColor, _size = param.size, size = _size === void 0 ? "lg" : _size, className = param.className, style = param.style;
    var theme = (0,emotion_element_f0de968e_browser_esm.u)();
    var sizeSwitch = function(titleSize) {
        var fontSize = theme.fontSize;
        switch(titleSize){
            case "xs":
                return fontSize === null || fontSize === void 0 ? void 0 : fontSize.xs;
            case "sm":
                return fontSize === null || fontSize === void 0 ? void 0 : fontSize.sm;
            case "md":
                return fontSize === null || fontSize === void 0 ? void 0 : fontSize.lg;
            case "lg":
                return fontSize === null || fontSize === void 0 ? void 0 : fontSize["2xl"];
            case "xl":
                return fontSize === null || fontSize === void 0 ? void 0 : fontSize["3xl"];
            case "xxl":
                return fontSize === null || fontSize === void 0 ? void 0 : fontSize["4xl"];
        }
    };
    return(//'flex items-center justify-center flex-wrap'
    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        style: style,
        className: (0,dist_clsx/* default */.Z)("flex items-center justify-center flex-wrap section-title", className),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui_Divider, {
                className: "basis-10 grow-0",
                height: "md",
                color: dividerColor
            }),
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui_Typography, {
                className: "py-4 px-2 grow-[two]",
                type: "h3",
                fontWeight: "Semi Bold",
                color: color,
                fontSize: sizeSwitch(size),
                children: children
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui_Divider, {
                className: "basis-10 grow",
                height: "md",
                color: dividerColor
            }),
            " "
        ]
    }));
}
/* harmony default export */ var base_ui_SectionTitle = (SectionTitle);

;// CONCATENATED MODULE: ./src/features/base-ui/TableCoins.js

function TableCoins_templateObject() {
    var data = _tagged_template_literal([
        "\n                                        font-family: ",
        ";\n                                    "
    ]);
    TableCoins_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n                                    font-family: ",
        ";\n                                "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n                                    direction: ltr;\n                                    font-family: ",
        ";\n                                "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n                                        direction: ltr;\n                                    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n                                        font-family: ",
        ";\n                                    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n                                        font-family: ",
        ";\n                                    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}







function TableCoins(param) {
    var _type = param.type, type = _type === void 0 ? "full" : _type, head = param.head;
    var ref;
    var theme = useTheme();
    var ref1 = useState({}), items = ref1[0], setItems = ref1[1];
    var ref2 = useState(true), loading = ref2[0], setLoading = ref2[1];
    var ref3 = useState(null), from_id = ref3[0], setFrom_id = ref3[1];
    useEffect(function() {
        fetch("/api/graphql", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                query: "{\n                    coinsLatest(meta: { limit: 20, from_id: ".concat(from_id ? '"'.concat(from_id, '"') : "null", "}) {\n                        from_id\n                        next_id\n                        prev_id\n                        data {\n                        id\n                        logo_path\n                        chart_path\n                        usd_price\n                        market_cap\n                        irr_price\n                        volume_24h\n                        symbol\n                        percent_change_1h\n                        }\n                    }\n                }")
            })
        }).then(function(response) {
            return response.json();
        }).then(function(param) {
            var data = param.data;
            setItems(data.coinsLatest);
            setLoading(false);
        });
    }, [
        from_id
    ]);
    if (loading) return /*#__PURE__*/ _jsx(Typography, {
        type: "h4",
        color: "warning",
        children: "در حال بارگزاری"
    });
    else if (items === null || items === void 0 ? void 0 : items.length) return /*#__PURE__*/ _jsx(Typography, {
        type: "h4",
        color: "danger",
        children: "خطا اتفاق افتاده"
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "overflow-x-auto",
                children: /*#__PURE__*/ _jsx(Table, {
                    head: head,
                    children: items === null || items === void 0 ? void 0 : (ref = items.data) === null || ref === void 0 ? void 0 : ref.map(function(coin, idx) {
                        var ref, ref1, ref2, ref3, ref4;
                        /*#__PURE__*/ return _jsxs("tr", {
                            children: [
                                /*#__PURE__*/ _jsx("td", {
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: clsx("flex items-center px-2", {
                                            "w-40 lg:w-auto": type === "full"
                                        }),
                                        css: css(TableCoins_templateObject(), (ref = theme.font) === null || ref === void 0 ? void 0 : ref.en),
                                        children: /*#__PURE__*/ _jsxs(Link, {
                                            href: "/coins/".concat(coin.id),
                                            style: "span.internal-link { a { display:flex; align-items:center;} }",
                                            children: [
                                                /*#__PURE__*/ _jsx(Image, {
                                                    noStyle: true,
                                                    alt: coin === null || coin === void 0 ? void 0 : coin.id,
                                                    src: coin.logo_path,
                                                    width: 30,
                                                    height: 30
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "mx-1 h-full",
                                                    children: coin === null || coin === void 0 ? void 0 : coin.id
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsx("td", {
                                    css: css(_templateObject1(), (ref1 = theme.font) === null || ref1 === void 0 ? void 0 : ref1.en),
                                    children: currencyFormat(coin === null || coin === void 0 ? void 0 : coin.usd_price, "USD", "us-US")
                                }),
                                /*#__PURE__*/ _jsx("td", {
                                    css: css(_templateObject2(), (ref2 = theme.font) === null || ref2 === void 0 ? void 0 : ref2.en),
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: clsx("", {
                                            "w-40 lg:w-auto": type === "full"
                                        }),
                                        children: (coin === null || coin === void 0 ? void 0 : coin.percent_change_1h) && /*#__PURE__*/ _jsx(ProfitOrLossCheck, {
                                            percentage: coin === null || coin === void 0 ? void 0 : coin.percent_change_1h.toFixed(3)
                                        })
                                    })
                                }),
                                type === "full" && /*#__PURE__*/ _jsx("td", {
                                    css: css(_templateObject3()),
                                    children: currencyFormat(coin === null || coin === void 0 ? void 0 : coin.irr_price, "IRR")
                                }),
                                type === "full" && /*#__PURE__*/ _jsx("td", {
                                    css: css(_templateObject4(), (ref3 = theme.font) === null || ref3 === void 0 ? void 0 : ref3.en),
                                    children: currencyFormat(coin === null || coin === void 0 ? void 0 : coin.volume_24h, "USD", "us-US")
                                }),
                                type === "full" && /*#__PURE__*/ _jsxs("td", {
                                    css: css(_templateObject5(), (ref4 = theme.font) === null || ref4 === void 0 ? void 0 : ref4.en),
                                    children: [
                                        " ",
                                        currencyFormat(coin === null || coin === void 0 ? void 0 : coin.market_cap, "USD", "us-US")
                                    ]
                                }),
                                type === "full" && /*#__PURE__*/ _jsx("td", {
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "w-40 lg:w-auto",
                                        children: /*#__PURE__*/ _jsx(Image, {
                                            alt: coin === null || coin === void 0 ? void 0 : coin.id,
                                            src: coin.chart_path,
                                            width: 100,
                                            height: 30
                                        })
                                    })
                                })
                            ]
                        }, idx);
                    })
                })
            }),
            type === "full" && /*#__PURE__*/ _jsx(SimplePagination, {
                next_id: items.next_id,
                prev_id: items.from_id === items.prev_id ? null : items.prev_id,
                setFrom_id: setFrom_id
            })
        ]
    });
}
/* harmony default export */ var base_ui_TableCoins = ((/* unused pure expression or super */ null && (TableCoins)));

;// CONCATENATED MODULE: ./src/features/base-ui/Pagination.js




function Pagination(param) {
    var _pageItems = param.pageItems, pageItems = _pageItems === void 0 ? 10 : _pageItems, _allItems = param.allItems, allItems = _allItems === void 0 ? 100 : _allItems, _displayItems = param.displayItems, displayItems = _displayItems === void 0 ? 4 : _displayItems, url = param.url;
    var allPages = allItems / pageItems;
    var firstItem = currentPage > 1 ? (currentPage - 1) * pageItems + 1 : 1;
    var ref = useState(1), currentPage = ref[0], setCurrentPage = ref[1];
    var displayArray = function(start, stop, step) {
        return Array.from({
            length: (stop - start) / step + 1
        }, function(_, i) {
            return start + i * step;
        });
    };
    var ref1 = useState(displayArray(0, displayItems - 1, 1)), showArray = ref1[0];
    // const lastCoinExist = () => {
    //     if (firstItem) return '&last_coin_name='
    // }
    var PAGE_URL = [
        url,
        "/v1/latest?step=",
        pageItems,
        "&first_index=",
        firstItem
    ].join("");
    useEffect(function() {
        fetch(PAGE_URL).then(function(response) {
            return response.json();
        }).then(function(data) {
            /*ignore*/ console.log("pagination success", data);
        }, //bug should use .catch
        function(error) {
            /*ignore*/ console.log("pagination danger", error);
        });
    }, [
        PAGE_URL,
        url
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: "pt-6 grid xl:grid-cols-3 justify-items-center",
        children: /*#__PURE__*/ _jsx(Card, {
            spacing: "md",
            shadow: "md",
            bordered: true,
            className: "xl:col-start-2",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "flex justify-center",
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        hoverColor: currentPage <= 1 ? "transparent" : "lighter",
                        onClick: function() {
                            return setCurrentPage(currentPage > 1 ? currentPage - 1 : currentPage);
                        },
                        disabled: currentPage <= 1,
                        children: /*#__PURE__*/ _jsx(BsArrowRightShort, {})
                    }),
                    currentPage > 1 && /*#__PURE__*/ _jsx(Button, {
                        hoverColor: currentPage === 1 ? "primary" : "lighter",
                        backgroundColor: currentPage === 1 ? "primary" : "white",
                        color: currentPage === 1 ? "white" : "text",
                        className: "mx-1",
                        onClick: function() {
                            setCurrentPage(1);
                        },
                        children: "1"
                    }),
                    currentPage > 2 && /*#__PURE__*/ _jsx("span", {
                        className: "mx-1",
                        children: "..."
                    }),
                    showArray.map(function(item, idx) {
                        return item + currentPage < allPages && /*#__PURE__*/ _jsx(Button, {
                            hoverColor: item + currentPage === currentPage ? "primary" : "lighter",
                            onClick: function() {
                                setCurrentPage(item + currentPage);
                            },
                            backgroundColor: item + currentPage === currentPage ? "primary" : "white",
                            color: item + currentPage === currentPage ? "white" : "text",
                            className: "mx-1",
                            children: item + currentPage
                        }, idx);
                    }),
                    currentPage < allPages - displayItems && /*#__PURE__*/ _jsx("span", {
                        className: "mx-1",
                        children: "..."
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        hoverColor: currentPage === allPages ? "primary" : "lighter",
                        backgroundColor: currentPage === allPages ? "primary" : "white",
                        color: currentPage === allPages ? "white" : "text",
                        className: "mx-1",
                        onClick: function() {
                            setCurrentPage(allPages);
                        },
                        children: allPages
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        hoverColor: currentPage >= allPages ? "transparent" : "lighter",
                        onClick: function() {
                            return setCurrentPage(currentPage < allPages ? currentPage + 1 : currentPage);
                        },
                        disabled: currentPage >= allPages,
                        children: /*#__PURE__*/ _jsx(BsArrowLeftShort, {})
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var base_ui_Pagination = ((/* unused pure expression or super */ null && (Pagination)));

;// CONCATENATED MODULE: ./src/features/base-ui/SimplePagination.js



function SimplePagination_SimplePagination(param) {
    var _next_id = param.next_id, next_id = _next_id === void 0 ? null : _next_id, _prev_id = param.prev_id, prev_id = _prev_id === void 0 ? null : _prev_id, setFrom_id = param.setFrom_id;
    return /*#__PURE__*/ _jsx("div", {
        className: "pt-6 grid xl:grid-cols-3 justify-items-center",
        children: /*#__PURE__*/ _jsx(Card, {
            spacing: "md",
            shadow: "md",
            bordered: true,
            className: "xl:col-start-2 ",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "flex justify-center",
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        hoverColor: prev_id ? "lighter" : "transparent",
                        onClick: function() {
                            return setFrom_id === null || setFrom_id === void 0 ? void 0 : setFrom_id(prev_id);
                        },
                        disabled: !prev_id,
                        children: /*#__PURE__*/ _jsx(BsArrowRightShort, {
                            className: "text-2xl"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        hoverColor: next_id ? "transparent" : "lighter",
                        onClick: function() {
                            return setFrom_id === null || setFrom_id === void 0 ? void 0 : setFrom_id(next_id);
                        },
                        disabled: !next_id,
                        children: /*#__PURE__*/ _jsx(BsArrowLeftShort, {
                            className: "text-2xl"
                        })
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var base_ui_SimplePagination = ((/* unused pure expression or super */ null && (SimplePagination_SimplePagination)));

// EXTERNAL MODULE: ./node_modules/react-icons/vsc/index.esm.js
var vsc_index_esm = __webpack_require__(14578);
;// CONCATENATED MODULE: ./src/features/utility/animation.js

var fadeInRight = /*#__PURE__*/ (0,emotion_react_browser_esm/* keyframes */.F4)("0%{opacity:0;-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0);}to{opacity:1;-webkit-transform:none;transform:none;}");
var fadeOutRight = /*#__PURE__*/ (/* unused pure expression or super */ null && (keyframes("0%{opacity:1;}to{opacity:0;-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0);}")));

;// CONCATENATED MODULE: ./src/features/base-ui/Modal.js





function Modal(param) {
    var children = param.children, style = param.style, visible = param.visible, onClose = param.onClose;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:fixed;top:0;right:0;background-color:rgba(0,0,0,0.7);backdrop-filter:blur(10px);width:100vw;height:100vh;z-index:99;display:", visible ? "flex" : "none", ";justify-content:center;align-items:center;animation:", fadeInRight, " 1s ease;", style),
        className: "modal",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:absolute;top:40px;right:40px;font-size:2.5rem;svg{color:#ffffff !important;}"),
                onClick: function() {
                    onClose === null || onClose === void 0 ? void 0 : onClose();
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(vsc_index_esm/* VscChromeClose */.S1K, {})
            }),
            children
        ]
    });
}
/* harmony default export */ var base_ui_Modal = (Modal);

;// CONCATENATED MODULE: ./src/features/base-ui/MegaMenu.js

function MegaMenu_templateObject() {
    var data = (0,src_tagged_template_literal/* default */.Z)([
        "\n            position: absolute;\n            width: 100%;\n            margin-left: auto;\n            margin-right: auto;\n            top: 85px;\n            left: 0;\n            right: 0;\n            z-index: 9;\n            .tabs {\n                flex-wrap: nowrap;\n                .button-group {\n                    margin-top: 1.5rem;\n                    flex-direction: column;\n                    border-left: 1px solid ",
        ";\n                    justify-content: flex-start;\n                    align-items: center;\n                    gap: 1rem;\n                    width: 20%;\n                    height: 100%;\n                    button {\n                        border-radius: ",
        ";\n                        ",
        "\n                        border: 1px dashed ",
        ";\n                        background-color: ",
        ";\n                        color: ",
        ";\n                        min-width: 8rem;\n                        padding-top: 0.5rem;\n                        padding-bottom: 0.5rem;\n                        justify-content: center;\n                        font-size: ",
        ";\n                    }\n                    .active-button {\n                        background-color: ",
        ";\n                        color: ",
        ";\n                    }\n                }\n                .tab-panel {\n                    ",
        "\n                    padding-right: 2rem;\n                }\n                .tab-content {\n                    display: flex;\n                }\n            }\n        "
    ]);
    MegaMenu_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var MegaMenu = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var menuData = param.menuData, _visible = param.visible, visible = _visible === void 0 ? false : _visible, onBlur = param.onBlur, onFocus = param.onFocus;
    var _$ref, _$ref1, _$ref2, _$ref3, _$ref4, _$ref5, _$ref6, _$ref7;
    var theme = (0,emotion_element_f0de968e_browser_esm.u)();
    var style = (0,emotion_react_browser_esm/* css */.iv)(MegaMenu_templateObject(), (_$ref = theme.colors) === null || _$ref === void 0 ? void 0 : _$ref.lighterGray, (_$ref1 = theme.borderRadius) === null || _$ref1 === void 0 ? void 0 : _$ref1.default, "" /* background-color: ${theme.colors.lightGray}; */ , (_$ref2 = theme.colors) === null || _$ref2 === void 0 ? void 0 : _$ref2.lightGray, (_$ref3 = theme.colors) === null || _$ref3 === void 0 ? void 0 : _$ref3.lighterGray, (_$ref4 = theme.colors) === null || _$ref4 === void 0 ? void 0 : _$ref4.lighter, (_$ref5 = theme.fontSize) === null || _$ref5 === void 0 ? void 0 : _$ref5.sm, (_$ref6 = theme.colors) === null || _$ref6 === void 0 ? void 0 : _$ref6.lighter, (_$ref7 = theme.colors) === null || _$ref7 === void 0 ? void 0 : _$ref7.white, "" /* width: 100%; */ );
    if (!visible) return null;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        ref: ref,
        className: "container",
        css: style,
        onMouseOver: onFocus,
        onMouseOut: onBlur,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui_Card, {
            bordered: true,
            shadow: "xl",
            style: "height: 100%;",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui_Tab, {
                tabs: menuData,
                children: menuData.map(function(item, idx) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui_TabPanel, {
                                style: "width:80%;",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui_MenuBody, {
                                    items: item.children
                                })
                            }),
                            item.thumbnail && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui_TabPanel, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui_Image/* default */.Z, {
                                    noStyle: true,
                                    src: item.thumbnail,
                                    width: 200,
                                    height: 120,
                                    alt: "flag"
                                })
                            })
                        ]
                    }, idx);
                })
            })
        })
    });
});
/* harmony default export */ var base_ui_MegaMenu = (MegaMenu);

;// CONCATENATED MODULE: ./src/features/base-ui/MenuBody.js





function MenuBody(param) {
    var _coloumn = param.coloumn, coloumn = _coloumn === void 0 ? 4 : _coloumn, _items = param.items, items = _items === void 0 ? [] : _items;
    var ref, ref1;
    var theme = (0,emotion_element_f0de968e_browser_esm.u)();
    var style = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:grid;grid-template-columns:repeat(", coloumn, ",minmax(0,1fr));a{border:1px dashed ", (ref = theme.colors) === null || ref === void 0 ? void 0 : ref.lightGray, ";padding:0.5rem;display:flex;align-items:center;justify-content:center;width:100%;height:48px;text-align:center;border-radius:", (ref1 = theme.borderRadius) === null || ref1 === void 0 ? void 0 : ref1.default, ";}");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: "gap-2",
        css: style,
        children: items.map(function(item, idx) {
            if (!item.thumbnail) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui_Link, {
                    href: item.link,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        className: "mx-2",
                        children: item.label
                    })
                }, idx);
            }
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(base_ui_Link, {
                href: item.link,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui_Image/* default */.Z, {
                        noStyle: true,
                        src: item.thumbnail,
                        width: 32,
                        height: 32,
                        alt: "flag"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        className: "mx-2",
                        children: item.label
                    })
                ]
            }, idx);
        })
    });
}
/* harmony default export */ var base_ui_MenuBody = (MenuBody);

// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var ai_index_esm = __webpack_require__(8193);
;// CONCATENATED MODULE: ./src/features/base-ui/Accordion.js




function Accordion(param) {
    var title = param.title, content = param.content;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var ref7 = (0,react.useState)(false), isActive = ref7[0], setIsActive = ref7[1];
    var theme = (0,emotion_element_f0de968e_browser_esm.u)();
    var style = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(".accordion-title{display:flex;justify-content:space-between;align-items:center;padding:0.3rem 0.5rem;background-color:", (ref = theme.colors) === null || ref === void 0 ? void 0 : (ref1 = ref.accordion) === null || ref1 === void 0 ? void 0 : ref1.headBackground, ";border-radius:", (ref2 = theme.borderRadius) === null || ref2 === void 0 ? void 0 : ref2.default, ";color:", (ref3 = theme.colors) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.accordion) === null || ref4 === void 0 ? void 0 : ref4.titleColor, ";}.accordion-open-ind{font-size:1.5em;}.accordion-content{padding:0.5rem;color:", (ref5 = theme.colors) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.accordion) === null || ref6 === void 0 ? void 0 : ref6.color, ";}");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: "accordion",
        css: style,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            className: "accordion-item",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    className: "accordion-title outline outline-offset-4 outline-1",
                    onClick: function() {
                        return setIsActive(!isActive);
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            className: "title",
                            children: title
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            className: "accordion-open-ind",
                            children: isActive ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ai_index_esm/* AiOutlineMinusCircle */._nT, {}) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ai_index_esm/* AiOutlinePlusCircle */.dEn, {})
                        })
                    ]
                }),
                isActive && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    className: "accordion-content",
                    children: content
                })
            ]
        })
    });
}
/* harmony default export */ var base_ui_Accordion = (Accordion);

;// CONCATENATED MODULE: ./src/features/base-ui/ShareButton.js




function ShareButton(param) {
    var title = param.title, url = param.url;
    //     const shareMode = useMemo(() => {
    //     if (navigator.share) return 'api'
    //     var standalone = window.navigator.standalone,
    //         userAgent = window.navigator.userAgent.toLowerCase(),
    //         safari = /safari/.test(userAgent),
    //         ios = /iphone|ipod|ipad/.test(userAgent)
    //     if (ios) {
    //         if (!standalone && safari) {
    //             // Safari
    //         } else if (!standalone && !safari) {
    //             // iOS webview
    //         }
    //     } else {
    //         if (userAgent.includes('wv')) {
    //             // Android webview
    //             return 'intent'
    //         } else {
    //             // Chrome
    //         }
    //     }
    // }, [])
    // const props = {}
    // if (shareMode === 'api')
    //     props.onClick = () => {
    //         if (navigator.share) {
    //             navigator.share({
    //                 title: title,
    //                 url: url
    //             })
    //             return
    //         }
    //     }
    // else
    // props.href = `intent://`
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui_Button, {
        icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(bs_index_esm/* BsShareFill */.Mp, {
            className: "inline-block"
        }),
        onClick: function() {
            if (typeof navigator === "undefined" && "share" in navigator) navigator.share({
                title: title,
                url: url
            });
        }
    });
}

;// CONCATENATED MODULE: ./src/features/base-ui/AnimatedCircle.js


function AnimatedCircle() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
        className: "flex h-3 w-3 relative",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                className: "animate-ping absolute inline-flex h-full w-full rounded-full bg-sky-400 opacity-75"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                className: "relative inline-flex rounded-full h-3 w-3 bg-sky-500"
            })
        ]
    });
}
/* harmony default export */ var base_ui_AnimatedCircle = (AnimatedCircle);

;// CONCATENATED MODULE: ./src/features/base-ui/MessageCard.js





function MessageCard(param) {
    var children = param.children;
    var ref;
    var theme = (0,emotion_element_f0de968e_browser_esm.u)();
    var mainStyle = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(".card{background-color:transparent;border:none;}");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: mainStyle,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui_Card, {
            bordered: true,
            className: "message-card",
            borderStyle: "square",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui_Typography, {
                type: "h3",
                fontSize: "1.2rem",
                align: "center",
                color: (ref = theme.colors) === null || ref === void 0 ? void 0 : ref.secGray,
                children: children
            })
        })
    });
}
/* harmony default export */ var base_ui_MessageCard = (MessageCard);

;// CONCATENATED MODULE: ./src/features/base-ui/Video.js





function Video(_param) {
    var src = _param.src, _type = _param.type, type = _type === void 0 ? "video/mp4" : _type, coverImage = _param.coverImage, others = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "type",
        "coverImage"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("video", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            controls: true,
            width: "100%",
            poster: coverImage
        }, others), {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
                    src: src,
                    type: type
                }),
                "Sorry, your browser doesnot support embedded videos."
            ]
        }))
    });
}
/* harmony default export */ var base_ui_Video = (Video);

// EXTERNAL MODULE: ./src/features/page-builder/SocialLinks.js
var SocialLinks = __webpack_require__(95209);
;// CONCATENATED MODULE: ./src/features/base-ui/Fab.js






function Fab() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var theme = (0,emotion_element_f0de968e_browser_esm.u)();
    var style = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-wrap:nowrap;position:fixed;bottom:5.5rem;right:2rem;background-color:", (ref = theme.colors) === null || ref === void 0 ? void 0 : ref.secondary, ";color:", (ref1 = theme.colors) === null || ref1 === void 0 ? void 0 : ref1.primary, ";z-index:99;border-radius:3rem;gap:0.5rem;justify-content:space-around;", (ref2 = config.theme) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.components) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.fab) === null || ref4 === void 0 ? void 0 : ref4.css);
    var innerStyle = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:inline-flex;padding:0.5rem;flex:1;min-width:fit-content;justify-content:center;a{display:flex;justify-content:center;align-items:center;gap:0.5rem;font-size:1.3rem;}");
    if (!((ref5 = config.texts) === null || ref5 === void 0 ? void 0 : ref5.fab)) return null;
    var items = (Array.isArray((ref6 = config.texts) === null || ref6 === void 0 ? void 0 : ref6.fab) ? (ref7 = config.texts) === null || ref7 === void 0 ? void 0 : ref7.fab : [
        (ref8 = config.texts) === null || ref8 === void 0 ? void 0 : ref8.fab
    ]).filter(function(i) {
        return Boolean(i.title);
    });
    if (!items.length) return null;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: style,
        children: items.map(function(i, idx) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(base_ui_Link, {
                external: true,
                href: i.link,
                css: [
                    innerStyle,
                    i.css
                ],
                children: [
                    Boolean(i.icon) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        className: "text-2xl",
                        children: (0,SocialLinks/* switchSocial */.j)(i.icon)
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        className: "title",
                        children: i.title
                    })
                ]
            }, idx);
        })
    });
}
/* harmony default export */ var base_ui_Fab = (Fab);

// EXTERNAL MODULE: ./src/utils/news.js
var news = __webpack_require__(98993);
;// CONCATENATED MODULE: ./src/features/base-ui/Media.js
/* eslint-disable @next/next/no-img-element */ /* eslint-disable jsx-a11y/alt-text */ 





function Media(param) {
    var media = param.media, thumbnail = param.thumbnail;
    var ref, ref1, ref2;
    var ref3;
    var mime = (ref3 = media === null || media === void 0 ? void 0 : (ref = media.file) === null || ref === void 0 ? void 0 : ref.mime) !== null && ref3 !== void 0 ? ref3 : "";
    var ref4;
    var ext = (ref4 = media === null || media === void 0 ? void 0 : (ref1 = media.file) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.ext) === null || ref2 === void 0 ? void 0 : ref2.toLocaleLowerCase()) !== null && ref4 !== void 0 ? ref4 : "";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        children: [
            thumbnail && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "my-6 relative h-64 lg:h-80",
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("img,video{width:100%;max-height:500px;object-fit:contain;}"),
                itemScope: true,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui_Image/* default */.Z, {
                    src: (0,news/* thumbnailSrc */.xX)(thumbnail),
                    layout: "fill",
                    width: "1200px",
                    height: "500px",
                    objectFit: "contain",
                    alt: thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.alt
                })
            }),
            media && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                className: "mt-4 relative",
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("img,video{width:100%;max-height:500px;object-fit:contain;}"),
                children: [
                    mime.indexOf("video") === 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("video", {
                        muted: true,
                        loop: true,
                        controls: true,
                        preload: "metadata",
                        width: "100%",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
                            src: (0,news/* thumbnailSrc */.xX)(media)
                        })
                    }),
                    mime.indexOf("audio") === 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("audio", {
                        style: {
                            width: "100%"
                        },
                        controls: true,
                        src: "/api/filedb/".concat(media.file.hash, ".").concat(media.file.ext, "#t=0.5"),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                            href: "/api/filedb/".concat(media.file.hash, ".").concat(media.file.ext, "#t=0.5"),
                            children: "دانلود فایل صوتی"
                        })
                    })
                ]
            }),
            ext.indexOf("doc") === 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ai_index_esm/* AiOutlineFileWord */.YPP, {}),
            ext.indexOf("xls") === 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ai_index_esm/* AiOutlineFileExcel */.BXA, {}),
            ext.indexOf("pdf") === 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ai_index_esm/* AiOutlineFilePdf */.ih9, {}),
            [
                "zip",
                "rar",
                "tar",
                "gz",
                "7z"
            ].indexOf(ext) !== -1 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ai_index_esm/* AiOutlineFileZip */.bmP, {})
        ]
    });
}
/* harmony default export */ var base_ui_Media = (Media);

// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 11 modules
var esm = __webpack_require__(74614);
;// CONCATENATED MODULE: ./src/features/base-ui/PaginationNxtPrev.js





function PaginationNxtPrev(param) {
    var _page = param.page, page = _page === void 0 ? 1 : _page, _lastPage = param.lastPage, lastPage = _lastPage === void 0 ? false : _lastPage, prevHreh = param.prevHreh, nxtHref = param.nxtHref;
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "news"
    ]).t;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "inline-flex gap-2",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(base_ui_Button, {
                type: "linkButton",
                hoverColor: page <= 1 ? "transparent" : "darkGray",
                color: page <= 1 ? "lighterGray" : "white",
                disabled: page <= 1,
                className: "flex-nowrap inline-flex",
                href: prevHreh,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(bs_index_esm/* BsArrowRightShort */.UE1, {
                        style: {
                            display: "inline"
                        }
                    }),
                    t("صفحه ی قبلی", {
                        ns: "common"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(base_ui_Button, {
                type: "linkButton",
                hoverColor: lastPage ? "transparent" : "darkGray",
                color: lastPage ? "lighterGray" : "white",
                disabled: lastPage,
                className: "flex-nowrap inline-flex",
                href: nxtHref,
                children: [
                    t("صفحه ی بعد", {
                        ns: "common"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(bs_index_esm/* BsArrowLeftShort */.i1r, {
                        style: {
                            display: "inline"
                        }
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var base_ui_PaginationNxtPrev = (PaginationNxtPrev);

// EXTERNAL MODULE: ./src/utils/index.js + 3 modules
var utils = __webpack_require__(12311);
;// CONCATENATED MODULE: ./src/features/base-ui/CommentCard.js







function CommentCard(param) {
    var comment = param.comment;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var theme = (0,emotion_element_f0de968e_browser_esm.u)();
    var mainStyle = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("max-width:92vw;.card-content{p.typography{overflow-x:auto;overflow-y:hidden;}}", (0,Utility/* MediaQuery */.zP)("md", "min"), "{max-width:42vw;}", (0,Utility/* MediaQuery */.zP)("lg", "min"), "{max-width:52vw;}", (0,Utility/* MediaQuery */.zP)("xl", "min"), "{max-width:92vw;}");
    var _username;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: mainStyle,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(base_ui_Card, {
            bordered: true,
            spacing: "md",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    className: "flex items-center",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui_Avatar, {
                            size: "small",
                            bgColor: "secGray",
                            color: "lighterGray",
                            isImg: false,
                            rounded: false,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(bs_index_esm/* BsPersonBoundingBox */.gW$, {})
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            type: "t",
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", (ref = theme.colors) === null || ref === void 0 ? void 0 : ref.info, ";font-size:", (ref1 = theme.fontSize) === null || ref1 === void 0 ? void 0 : ref1.sm, ";background-color:", (ref2 = theme.colors) === null || ref2 === void 0 ? void 0 : ref2.lighterGray, ";padding:0.1rem 0.5rem;margin-left:1rem;"),
                            children: (_username = comment.username) !== null && _username !== void 0 ? _username : "ناشناس"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui_Avatar, {
                            size: "small",
                            bgColor: "secGray",
                            color: "lighterGray",
                            isImg: false,
                            rounded: false,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(bs_index_esm/* BsCalendarCheck */.$W1, {})
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            type: "t",
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", (ref3 = theme.colors) === null || ref3 === void 0 ? void 0 : ref3.darker, ";font-size:", (ref4 = theme.fontSize) === null || ref4 === void 0 ? void 0 : ref4.sm, ";background-color:", (ref5 = theme.colors) === null || ref5 === void 0 ? void 0 : ref5.lighterGray, ";padding:0.1rem 0.5rem;margin-left:1rem;"),
                            children: (0,utils/* distanceFromNow */.zM)(comment.created_at)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui_Typography, {
                    type: "p",
                    color: "medGray",
                    className: "mt-4",
                    children: comment.content
                })
            ]
        })
    });
}
/* harmony default export */ var base_ui_CommentCard = (CommentCard);

;// CONCATENATED MODULE: ./src/features/base-ui/MiscCarousel.js








var carousel = function(slider) {
    var rotate = function rotate() {
        var deg = 360 * slider.track.details.progress;
        slider.container.style.transform = "translateZ(-".concat(z, "px) rotateY(").concat(-deg, "deg)");
    };
    var z = 300;
    slider.on("created", function() {
        var deg = 360 / slider.slides.length;
        slider.slides.forEach(function(element, idx) {
            element.style.transform = "rotateY(".concat(deg * idx, "deg) translateZ(").concat(z, "px)");
        });
        rotate();
    });
    slider.on("detailsChanged", rotate);
};
function MiscCarousel(param) {
    var children = param.children;
    var ref = (0,react.useState)(0), currentSlide = ref[0], setCurrentSlide = ref[1];
    var ref1 = (0,react.useState)(false), loaded = ref1[0], setLoaded = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,keen_slider_react/* useKeenSlider */.E)({
        loop: true,
        controls: true,
        selector: ".carousel__cell",
        renderMode: "custom",
        mode: "free-snap",
        initial: 0,
        slideChanged: function slideChanged(slider) {
            setCurrentSlide(slider.track.details.rel);
        },
        created: function created() {
            setLoaded(true);
        }
    }, [
        carousel
    ]), 2), sliderRef = ref2[0], instanceRef = ref2[1];
    var mainStyle = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)('[class^="number-slide"],[class*=" number-slide"]{background:grey;display:flex;align-items:center;justify-content:center;font-size:50px;color:#fff;font-weight:500;height:200px;max-height:100vh;}.wrapper{display:flex;justify-content:center;}.scene{width:240px;height:130px;perspective:90px;position:relative;}.scene .carousel.keen-slider{width:100%;height:100%;position:absolute;overflow:visible;transform:translateZ(-288px);transform-style:preserve-3d;}.carousel__cell{position:absolute;width:200px;left:20px;height:130px;border:1px solid rgba(0,0,0,0.3);}.dots{display:flex;padding:10px 0;justify-content:center;}.dot{border:none;width:10px;height:10px;background:#c5c5c5;border-radius:50%;margin:0 5px;padding:5px;cursor:pointer;}.dot:focus{outline:none;}.dot.active{background:#000;}.arrow{width:30px;height:30px;position:absolute;top:50%;transform:translateY(-50%);-webkit-transform:translateY(-50%);fill:#fff;cursor:pointer;}.arrow--left{left:5px;}.arrow--right{left:auto;right:5px;}.arrow--disabled{fill:rgba(255,255,255,0.5);}', (0,Utility/* MediaQuery */.zP)("md", "min"), "{.scene{width:310px;height:192px;perspective:1000px;}.carousel__cell{position:absolute;width:280px;left:20px;height:192px;}}");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: mainStyle,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        className: "wrapper",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            className: "scene",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                className: "carousel keen-slider",
                                ref: sliderRef,
                                children: children
                            })
                        })
                    }),
                    loaded && instanceRef.current && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MiscCarousel_Arrow, {
                                left: true,
                                onClick: function(e) {
                                    var ref;
                                    return e.stopPropagation() || ((ref = instanceRef.current) === null || ref === void 0 ? void 0 : ref.prev());
                                },
                                disabled: currentSlide === 0
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MiscCarousel_Arrow, {
                                onClick: function(e) {
                                    var ref;
                                    return e.stopPropagation() || ((ref = instanceRef.current) === null || ref === void 0 ? void 0 : ref.next());
                                },
                                disabled: currentSlide === instanceRef.current.track.details.slides.length - 1
                            })
                        ]
                    })
                ]
            }),
            loaded && instanceRef.current && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "dots",
                children: (0,_to_consumable_array/* default */.Z)(Array(instanceRef.current.track.details.slides.length).keys()).map(function(idx) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                        onClick: function() {
                            var ref;
                            (ref = instanceRef.current) === null || ref === void 0 ? void 0 : ref.moveToIdx(idx);
                        },
                        className: "dot" + (currentSlide === idx ? " active" : "")
                    }, idx);
                })
            })
        ]
    });
}
function MiscCarousel_Arrow(props) {
    var disabeld = props.disabled ? " arrow--disabled" : "";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
        onClick: props.onClick,
        className: "arrow ".concat(props.left ? "arrow--left" : "arrow--right", " ").concat(disabeld),
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        children: [
            props.left && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z"
            }),
            !props.left && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/features/base-ui/index.js


































/***/ }),

/***/ 95209:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ switchSocial; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20442);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70917);
/* harmony import */ var _base_ui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82843);
/* harmony import */ var react_icons_io__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51649);
/* harmony import */ var react_icons_ai__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8193);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89583);
/* harmony import */ var react_icons_io5__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60155);







var switchSocial = function(socialType) {
    switch(socialType){
        case "mobile":
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(react_icons_fa__WEBPACK_IMPORTED_MODULE_2__/* .FaMobileAlt */ .XEH, {});
        case "phone":
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(react_icons_fa__WEBPACK_IMPORTED_MODULE_2__/* .FaPhone */ .I7T, {});
        case "whatsapp":
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(react_icons_io__WEBPACK_IMPORTED_MODULE_3__/* .IoLogoWhatsapp */ .ff9, {});
        case "instagram":
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(react_icons_ai__WEBPACK_IMPORTED_MODULE_4__/* .AiFillInstagram */ .t0C, {});
        case "twitter":
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(react_icons_io__WEBPACK_IMPORTED_MODULE_3__/* .IoLogoTwitter */ .JUd, {});
        case "youtube":
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(react_icons_io__WEBPACK_IMPORTED_MODULE_3__/* .IoLogoYoutube */ .tPx, {});
        case "linkedin":
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(react_icons_io__WEBPACK_IMPORTED_MODULE_3__/* .IoLogoLinkedin */ .gXb, {});
        case "telegram":
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(react_icons_fa__WEBPACK_IMPORTED_MODULE_2__/* .FaTelegramPlane */ .AGi, {});
        case "rss":
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(react_icons_io__WEBPACK_IMPORTED_MODULE_3__/* .IoLogoRss */ .OdA, {});
        case "email":
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(react_icons_io5__WEBPACK_IMPORTED_MODULE_5__/* .IoMail */ .GYo, {});
    }
};
function SocialLinks(param) {
    var style = param.style, socials = param.socials, color = param.color, hoverColor = param.hoverColor;
    var ref;
    var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.u)();
    var footerColor = theme.colors.websiteFooter.color;
    var footerHoverColor = theme.colors.websiteFooter.hover;
    var socialStyle = /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)("display:flex;", style);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("div", {
        css: socialStyle,
        children: (ref = socials === null || socials === void 0 ? void 0 : socials.filter(Boolean)) === null || ref === void 0 ? void 0 : ref.map(function(social, idx) {
            var ref;
            /*#__PURE__*/ return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_base_ui__WEBPACK_IMPORTED_MODULE_0__/* .Link */ .rU, {
                color: color || footerColor,
                hoverColor: hoverColor || footerHoverColor,
                href: social === null || social === void 0 ? void 0 : social.href,
                className: "p-2",
                external: (social === null || social === void 0 ? void 0 : (ref = social.href) === null || ref === void 0 ? void 0 : ref.indexOf("/")) !== 0,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("span", {
                    className: "text-2xl social-icon",
                    children: switchSocial(social === null || social === void 0 ? void 0 : social.name)
                })
            }, idx);
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (SocialLinks);


/***/ }),

/***/ 98993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SP": function() { return /* binding */ getNewsContent; },
/* harmony export */   "iu": function() { return /* binding */ newsDisplayedPubDate; },
/* harmony export */   "ju": function() { return /* binding */ posterSrc; },
/* harmony export */   "xX": function() { return /* binding */ thumbnailSrc; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10253);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12311);
/* harmony import */ var _config_json__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51181);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_2__);




function thumbnailSrc(thumbnail) {
    var ref;
    if (!(thumbnail === null || thumbnail === void 0 ? void 0 : (ref = thumbnail.file) === null || ref === void 0 ? void 0 : ref.hash)) return null;
    if (thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.title) return "/api/filedb/".concat(thumbnail.file.hash, "/").concat(thumbnail.title.split(".")[0], ".").concat(thumbnail.file.ext);
    return "/api/filedb/".concat(thumbnail.file.hash, ".").concat(thumbnail.file.ext);
}
function posterSrc(media) {
    var ref;
    if (!(media === null || media === void 0 ? void 0 : (ref = media.file) === null || ref === void 0 ? void 0 : ref.hash)) return null;
    return "/api/filedb/".concat(media.file.hash, "c.jpg");
}
function getNewsContent(news) {
    var inlineNews = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], t = arguments.length > 2 ? arguments[2] : void 0, ads = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [], options = arguments.length > 4 ? arguments[4] : void 0;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25;
    if (!(news === null || news === void 0 ? void 0 : news.content)) return "";
    var contentBlocks = news.content.split("</p>").map(function(c) {
        return "".concat(c, "</p>");
    });
    var insertContentAt = {
        1: [],
        2: [],
        3: [],
        4: [],
        5: [],
        6: [],
        7: []
    };
    if ((ref = _config_json__WEBPACK_IMPORTED_MODULE_1__.integrations) === null || ref === void 0 ? void 0 : (ref1 = ref.yektanet) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.hamsan) === null || ref2 === void 0 ? void 0 : ref2.inline) insertContentAt[1].push('<div class="inline-1">'.concat(_config_json__WEBPACK_IMPORTED_MODULE_1__ === null || _config_json__WEBPACK_IMPORTED_MODULE_1__ === void 0 ? void 0 : (ref3 = _config_json__WEBPACK_IMPORTED_MODULE_1__.integrations) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.yektanet) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.hamsan) === null || ref5 === void 0 ? void 0 : ref5.inline, "</div>"));
    if ((ref6 = _config_json__WEBPACK_IMPORTED_MODULE_1__.integrations) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.yektanet) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.hamsan) === null || ref8 === void 0 ? void 0 : ref8.id_inline2) insertContentAt[2].push('<div class="inline-2">'.concat(_config_json__WEBPACK_IMPORTED_MODULE_1__.integrations.yektanet.hamsan.inline2, "</div>"));
    if ((ref9 = _config_json__WEBPACK_IMPORTED_MODULE_1__.integrations) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.yektanet) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.hamsan) === null || ref11 === void 0 ? void 0 : ref11.id_inline3) insertContentAt[3].push('<div class="inline-3">'.concat(_config_json__WEBPACK_IMPORTED_MODULE_1__.integrations.yektanet.hamsan.inline3, "</div>"));
    if ((ref12 = _config_json__WEBPACK_IMPORTED_MODULE_1__.integrations) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.yektanet) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.hamsan) === null || ref14 === void 0 ? void 0 : ref14.id_inline5) insertContentAt[5].push('<div class="inline-5">'.concat(_config_json__WEBPACK_IMPORTED_MODULE_1__.integrations.yektanet.hamsan.inline5, "</div>"));
    if ((ref15 = _config_json__WEBPACK_IMPORTED_MODULE_1__.integrations) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.yektanet) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.hamsan) === null || ref17 === void 0 ? void 0 : ref17.id_inline7) insertContentAt[7].push('<div class="inline-7">'.concat(_config_json__WEBPACK_IMPORTED_MODULE_1__.integrations.yektanet.hamsan.inline7, "</div>"));
    if ((ref18 = _config_json__WEBPACK_IMPORTED_MODULE_1__.integrations) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.sanjagh) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.hamsan) === null || ref20 === void 0 ? void 0 : ref20.id_inline) insertContentAt[1].push('<div><div id="'.concat(_config_json__WEBPACK_IMPORTED_MODULE_1__.integrations.sanjagh.hamsan.id_inline, '"></div></div>'));
    if ((ref21 = _config_json__WEBPACK_IMPORTED_MODULE_1__.integrations) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.mediaad) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.hamsan) === null || ref23 === void 0 ? void 0 : ref23.id_inline) insertContentAt[1].push('<div><div id="'.concat(_config_json__WEBPACK_IMPORTED_MODULE_1__.integrations.mediaad.hamsan.id_inline, '"></div></div>'));
    var inlineAds = ads.filter(function(a) {
        return a.location && a.location.indexOf("news_inline_p") === 0;
    });
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = inlineAds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var ad = _step.value;
            var paragraph = Number(ad.location.replace("news_inline_p", ""));
            insertContentAt[paragraph].push(ad.content);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var additions = 0;
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = Object.entries(insertContentAt)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var _value = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_step1.value, 2), position = _value[0], adsToInsert = _value[1];
            if (!adsToInsert.length) continue;
            contentBlocks.splice(Number(position) + additions++, 0, '<div id="inlinead'.concat(position, '" data-adtitle="میان متنی پاراگراف ').concat(position, '">').concat(adsToInsert.join("\n"), "</div>"));
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    if ((inlineNews === null || inlineNews === void 0 ? void 0 : inlineNews.length) > 0) {
        var inlinenewsTemplate = '<div\n        style="\n            background-color: #fefae0;\n            padding: 20px;\n            border-radius: 0.5rem;\n            border: 1px solid #faedcd;\n            margin: 10px 0;\n        "\n    >\n        <h3\n            style="\n                color: #990F00;\n                font-size: 1.5rem;\n            "\n        >\n            '.concat(t("در میان اخبار", {
            ns: "news"
        }), '\n        </h3>\n        <ul\n            style="\n                list-style-type: circle;\n                list-style: inside;\n                color: #FF5A47;\n                font-size: 1rem;\n                line-height: 1.6rem;\n                margin-top: 10px;\n                ').concat(options === null || options === void 0 ? void 0 : options.inlineNewsStyleStr, '\n            "\n        >\n        ').concat(inlineNews.map(function(n) {
            return "\n            <li>\n                <a ".concat(n.forward_link ? 'rel="nofollow"' : "", ' href="').concat((0,___WEBPACK_IMPORTED_MODULE_0__/* .generateUrl */ .nu)(n, "news"), '" style="').concat(options === null || options === void 0 ? void 0 : options.inlineNewsLinkStyleStr, '">\n                    ').concat(n.title, "\n                </a>\n            </li>\n            ");
        }).join(""), "\n        </ul>\n    </div>");
        contentBlocks.splice(Math.ceil(contentBlocks.length / 2), 0, inlinenewsTemplate);
    }
    var ref26, ref27;
    return "".concat((ref26 = (ref24 = news.newsTemplateTop) === null || ref24 === void 0 ? void 0 : ref24.content) !== null && ref26 !== void 0 ? ref26 : "").concat(contentBlocks.join("")).concat((ref27 = (ref25 = news.newsTemplateBottom) === null || ref25 === void 0 ? void 0 : ref25.content) !== null && ref27 !== void 0 ? ref27 : "");
}
function newsDisplayedPubDate(news) {
    var format = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "YYYY/MM/DD HH:mm";
    if (!(news === null || news === void 0 ? void 0 : news.published_at) && !(news === null || news === void 0 ? void 0 : news.selected_published_at)) return null;
    var _selected_published_at;
    var date = dayjs__WEBPACK_IMPORTED_MODULE_2___default()((_selected_published_at = news.selected_published_at) !== null && _selected_published_at !== void 0 ? _selected_published_at : news.published_at);
    if (!date.isValid()) return null;
    // no need as selected_published_at is not time corrected
    // if (Number(news.timecorrection)) date = date.add(Number(news.timecorrection) * -1, 'minute')
    if (format === "iso") return date.toISOString();
    if (format === "date") return date.toDate();
    return (0,___WEBPACK_IMPORTED_MODULE_0__/* .formatDate */ .p6)(date, format);
}


/***/ })

}]);